import BaseApiService from '../baseApi.service';

export default class AccessRoleService extends BaseApiService {
  readonly basePath: string = 'accessrole/v1';
  constructor(props = null) {
    super(props);
  }
}
